import type { DashboardData, Prompt } from "../types";
import { request } from "./client";

export function getDashboard(): Promise<DashboardData> {
	return request("/api/dashboard");
}

export function getAlternativePrompt(excludeIds: number[]): Promise<Prompt> {
	const params = excludeIds.map((id) => `exclude_ids=${id}`).join("&");
	return request(`/api/prompts/alternative${params ? `?${params}` : ""}`);
}
